import { AppStorage } from 'src/utils'

// Quem vê cada perspectiva (D25, 22/10/2026): a AG entra com viewer e o Bruno com manager; os dois veem os
// dashboards de negócio. Operação técnica só para admin. A mesma tabela está no servidor
// (apps/server/src/dashboard/dashboard.acesso.ts), que é quem confere de fato em cada rota.

export type Perspectiva = 'operacao' | 'negocios' | 'parceiros' | 'consultas'

export type DefinicaoPerspectiva = {
    id: Perspectiva
    titulo: string
    pergunta: string
    papeis: ReadonlySet<string>
    /** Já tem tela. */
    pronta: boolean
}

// As de negócio primeiro: a aba aberta ao entrar é a primeira que o papel pode ver. Consultas de lead abre: é o
// painel que substitui o Power BI que a AG usa hoje (E19).
export const PERSPECTIVAS: readonly DefinicaoPerspectiva[] = [
    {
        id: 'consultas',
        titulo: 'Consultas de lead',
        pergunta: 'O que os parceiros pedem e o que a LIA responde?',
        papeis: new Set(['admin', 'manager', 'viewer']),
        pronta: true
    },
    {
        id: 'negocios',
        titulo: 'Negócios e disputas',
        pergunta: 'Como está a carteira e quem disputa o quê?',
        papeis: new Set(['admin', 'manager', 'viewer']),
        pronta: true
    },
    {
        id: 'parceiros',
        titulo: 'Parceiros',
        pergunta: 'Quem usa a LIA e com que resultado?',
        papeis: new Set(['admin', 'manager', 'viewer']),
        pronta: true
    },
    {
        id: 'operacao',
        titulo: 'Operação técnica',
        pergunta: 'A LIA está entregando as mensagens?',
        papeis: new Set(['admin']),
        pronta: true
    }
]

/** Perspectivas com tela que o papel pode ver, na ordem do menu. */
export function perspectivasDoPapel(papel: string | null | undefined): DefinicaoPerspectiva[] {
    return PERSPECTIVAS.filter((p) => p.pronta && p.papeis.has(`${papel ?? ''}`))
}

/** O item "Dashboards" do menu aparece para quem vê ao menos uma perspectiva. */
export function podeVerDashboards(): boolean {
    return perspectivasDoPapel(AppStorage.singleton().userRole).length > 0
}
